<div mat-dialog-title>
  <div class="row row--space-between row--valign-center">
    <label class="semi-bold">{{ 'App.Signature.Labels.ReceiverSignature' | translate }}</label>
    <button mat-button (click)="closePad()" class="float-right">
      <span class="icon-x"></span>
    </button>
  </div>  
</div>
<!-- Signature Section -->
<div mat-dialog-content>
  <canvas #canvas height="200"></canvas>
  <mat-error *ngIf="signatureNeeded">
    {{ 'App.Signature.Labels.SignatureRequired' | translate }}
  </mat-error>
</div>
<!-- Buttons Section -->
<div class="row row--space-between" mat-dialog-actions>  
  <button mat-button class="column-lg--6 column-sm--12 column--12 secondary-button rounded" (click)="clearPad()">
    <span class="icon-x mr--sm"></span>
    <span>{{ 'App.Signature.Buttons.Clear' | translate }}</span>
  </button>
  <button mat-button class="column-lg--6 column-sm--12 column--12 primary-button rounded" (click)="savePad()">
    <span class="icon-check mr--sm"></span>
    <span>{{ 'App.Signature.Buttons.Confirm' | translate }}</span>
  </button>    
</div>